<div class="search-container" id="header-search-container">
  @if (canChooseOrderType) {
    <div class="d-inline-block w-130px">
      <ng-select
        id="search-order-type-select"
        class="order-type--select font-5"
        [items]="orderTypes"
        bindValue="id"
        [searchable]="false"
        [(ngModel)]="selectedOrderType"
        (change)="onSelectOrderType($event)"
        [clearable]="false"
      >
        <ng-template ng-label-tmp let-item="item">
          {{ item.label }}
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          {{ item.label }}
        </ng-template>
      </ng-select>
    </div>
  }
  <div class="search-input">
    <input
      id="header-search-input"
      type="text"
      placeholder="Search"
      autocomplete="off"
      class="form-control"
      [(ngModel)]="searchText"
      #searchInput
    />
    @if (searchText) {
      <button
        id="header-search-clear-btn"
        class="btn-close"
        (click)="onClearSearch()"
      ></button>
    }
    <button
      id="header-search-submit-btn"
      class="search-button"
      title="Search"
      (click)="onSearch()"
    >
      <i class="fal fa-search"></i>
    </button>
  </div>
</div>
